import { useState } from 'react';
import { type PlanFilters, type SortOption, emptyFilters, sortOptions } from './types';
import { countActiveFilters, hasActiveFilters } from './filterUtils';

/**
 * Filter- og sorteringstilstand for planlista. Selve filtreringen skjer i
 * tjenesten — se `toArealplanQuery` og `useArealplanPages`.
 */
export interface UsePlanFilterReturn {
    filters: PlanFilters;
    setFilters: (f: PlanFilters) => void;
    sortOption: SortOption;
    setSortOption: (o: SortOption) => void;
    activeFilterCount: number;
    hasActive: boolean;
    resetFilters: () => void;
}

export function usePlanFilter(): UsePlanFilterReturn {
    const [filters, setFilters] = useState<PlanFilters>(emptyFilters);
    const [sortOption, setSortOption] = useState<SortOption>(sortOptions[0]);

    return {
        filters,
        setFilters,
        sortOption,
        setSortOption,
        activeFilterCount: countActiveFilters(filters),
        hasActive: hasActiveFilters(filters),
        resetFilters: () => setFilters(emptyFilters),
    };
}
